import { createAsyncThunk } from "@reduxjs/toolkit";

import { PaymentMethods } from "../types/paymentMethods";

import { ThunkConfig } from "@/app/providers/StoreProvider";
import { ApiError } from "@/shared/types";
import { handleError } from "@/shared/lib/helpers/utils";

export const fetchPaymentMethods = createAsyncThunk<PaymentMethods, void, ThunkConfig<ApiError>>(
  "payment/fetchPaymentMethods",
  async (_, thunkApi) => {
    const { extra, rejectWithValue } = thunkApi;

    try {
      const response = await extra.api.get<PaymentMethods>("/api/billing/payment_method");

      return response.data;
    } catch (err) {
      return rejectWithValue(handleError(err));
    }
  }
);
